import SquareCheckBox from '../../checkBox/SquareCheckBox'
import React, { useEffect, useState } from 'react'
import './PromotionMarketplaceComponent.css'
import Text from '../../text/Text'
import SelectFilterAsync from '../../SelectFilterAsync'
import { getFilterProducts } from '../../../services/amipos'

export enum SectionsEnum {
    percentage = 'Desc. porcentaje total de compra',
    deliveryFree = 'Desc. en delivery gratis',
    specificProduct = 'Desc. producto especifico',
}

export enum SectionsKeyEnum {
    percentage = 'DescuentoMedioPago',
    deliveryFree = 'DescuentoDelivery',
    specificProduct = 'DescuentoSKU',
}

const days = ['LUN', 'MAR', 'MIER', 'JUE', 'VIE', 'SAB', 'DOM']

interface IData {
    product: IProductSelected | undefined
    percentage: string | undefined
    selected: string | undefined
    amount: string | undefined
    stock: string | undefined
    check: boolean
    days: string[]
    step: number
    startTime: string
    endTime: string
}

export interface IOnChangeDataPromotionOnline extends IData {
    valid: boolean
}

interface IProductSelected {
    value: {
        sku: string
        maximunStock: number
    }
    label: string
}

export function PromotionMarketPlaceComponent(properties: {
    onChange?: (data: IOnChangeDataPromotionOnline) => void
}) {
    const [steps, setSteps] = useState(0)

    const [optionsSelect, setOptionsSelect] = useState<string[]>([])
    const [showOptionSelect, setShowOptionSelect] = useState(false)
    const [optionSelected, setOptionSelected] = useState<string>()
    const [daysSelected, setDaysSelected] = useState<string[]>([])
    const [product, setProduct] = useState<IProductSelected>()
    const [check, setCheck] = useState(false)

    const [startTime, setStartTime] = useState('00:00')
    const [endTime, setEndTime] = useState('23:59')

    const [stock, setStock] = useState<string>()
    const [amount, setAmount] = useState<string>()
    const [percentage, setPercentage] = useState<string>()

    useEffect(() => {
        setOptionsSelect(Object.values(SectionsEnum))
    }, [])

    const validateTime = (text: string) => {
        return /^([01]\d|2[0-3]):([0-5]\d)$/.test(text)
    }

    const validationData = (data: IData): boolean => {
        switch (data.selected) {
            case SectionsEnum.percentage:
                return (
                    data.percentage !== undefined &&
                    /^([0-9])*$/.test(data.percentage) &&
                    Number(data.percentage) > 0 &&
                    Number(data.percentage) <= 100 &&
                    data.amount !== undefined &&
                    /^([0-9])*$/.test(data.amount) &&
                    (data.check ||
                        (data.days.length > 0 &&
                            data.startTime.length > 0 &&
                            data.endTime.length > 0 &&
                            validateTime(data.startTime) &&
                            validateTime(data.endTime)))
                )
            case SectionsEnum.deliveryFree:
                return (
                    data.amount !== undefined &&
                    /^([0-9])*$/.test(data.amount) &&
                    (data.check ||
                        (data.days.length > 0 &&
                            data.startTime.length > 0 &&
                            data.endTime.length > 0 &&
                            validateTime(data.startTime) &&
                            validateTime(data.endTime)))
                )
            case SectionsEnum.specificProduct:
                return (
                    (data.percentage !== undefined &&
                        /^([0-9])*$/.test(data.percentage) &&
                        Number(data.percentage) > 0 &&
                        Number(data.percentage) <= 100 &&
                        data.product !== undefined &&
                        data.stock !== undefined &&
                        /^([0-9])*$/.test(data.stock) &&
                        Number(data.stock) > 0 &&
                        Number(data.product.value.maximunStock) >=
                            Number(data.stock) &&
                        data.check) ||
                    (data.days.length > 0 &&
                        data.startTime.length > 0 &&
                        data.endTime.length > 0 &&
                        validateTime(data.startTime) &&
                        validateTime(data.endTime))
                )
            default:
                return false
        }
    }

    const handlerChangeData = (
        key:
            | 'selected'
            | 'amount'
            | 'percentage'
            | 'days'
            | 'check'
            | 'step'
            | 'product'
            | 'startTime'
            | 'endTime'
            | 'stock',
        value: string | boolean | string[] | number | IProductSelected
    ) => {
        if (properties.onChange) {
            const data: IData = {
                selected: optionSelected,
                percentage: percentage,
                startTime: startTime,
                days: daysSelected,
                endTime: endTime,
                product: product,
                amount: amount,
                check: check,
                stock: stock,
                step: steps,
                [key]: value,
            }

            properties.onChange({ ...data, valid: validationData(data) })
        }
    }

    const validateExistDay = (day: string) => {
        return daysSelected.includes(day)
    }

    const switchDay = (day: string) => {
        setDaysSelected((oldDaysSelected) => {
            if (oldDaysSelected.includes(day)) {
                handlerChangeData(
                    'days',
                    oldDaysSelected.filter((d) => d !== day)
                )
                return oldDaysSelected.filter((d) => d !== day)
            } else {
                handlerChangeData('days', [...oldDaysSelected, day])
                return [...oldDaysSelected, day]
            }
        })
    }

    const handlerNextStep = () => {
        handlerChangeData('step', steps + 1)
        setSteps(steps + 1)
    }

    const handlerPressSelect = (value: string) => {
        setShowOptionSelect(false)
        handlerChangeData('selected', value)
        setOptionSelected(value)
        handlerNextStep()
    }

    const header = () => {
        return (
            <div className="promotionMarketplaceHeader">
                <Text
                    label="🛒  Marketplace"
                    fontSize={24}
                    color="#656565"
                    fontWeight={600}
                />
            </div>
        )
    }

    const select = ({ disabled }: { disabled?: boolean }) => {
        return (
            <div className="promotionMarketplaceSelectContainer">
                <div className="promotionMarketplaceSelectContent">
                    <button
                        className="promotionMarketplaceSelectFirst"
                        onClick={() => {
                            if (!disabled) {
                                setShowOptionSelect(!showOptionSelect)
                                setSteps(1)
                            }
                        }}
                    >
                        <Text
                            label={
                                optionSelected
                                    ? optionSelected
                                    : 'Selecciona una opción'
                            }
                            color="#565656"
                            fontSize={15}
                        />
                    </button>
                    {showOptionSelect &&
                        optionsSelect.map((item, index) => (
                            <div
                                key={index}
                                className="promotionMarketplaceSelectItem"
                            >
                                <button
                                    onClick={() => handlerPressSelect(item)}
                                    className="promotionMarketplaceSelectItemBtn"
                                >
                                    <Text label={item} fontSize={15} />
                                </button>
                            </div>
                        ))}
                </div>
            </div>
        )
    }

    const input = (properties: {
        label: string
        value?: string
        placeholder?: string
        onChange?: (text: string) => void
        input?: React.InputHTMLAttributes<HTMLInputElement>
    }) => {
        return (
            <div className="promotionMarketplaceInputContainer">
                <Text
                    fontSize={16}
                    color="#565656"
                    fontWeight={600}
                    label={properties.label}
                />
                <input
                    {...properties.input}
                    value={properties.value}
                    placeholder={properties.placeholder}
                    onChange={(e) =>
                        properties.onChange &&
                        properties.onChange(e.target.value)
                    }
                    className="promotionMarketplaceInput"
                />
            </div>
        )
    }

    const inputTime = (properties: {
        value?: string
        placeholder?: string
        onChange?: (text: string) => void
        input?: React.InputHTMLAttributes<HTMLInputElement>
    }) => {
        const handleChange = (text: string) => {
            const inputValue = text.replace(/[^0-9]/g, '')
            let formattedTime = ''

            if (inputValue.length >= 2) {
                formattedTime += inputValue.slice(0, 2)
                if (inputValue.length > 2) {
                    formattedTime += ':' + inputValue.slice(2, 4)
                }
            } else {
                formattedTime += inputValue
            }

            if (properties.onChange) {
                properties.onChange(formattedTime)
            }
        }

        return (
            <>
                <div className="promotionMarketplaceInputTimeContainer">
                    <input
                        {...properties.input}
                        value={properties.value}
                        placeholder={properties.placeholder}
                        className="promotionMarketplaceInputTime"
                        onChange={(e) => handleChange(e.target.value)}
                    />
                </div>
            </>
        )
    }

    const AvailabilityDays = () => {
        return (
            <div className="promotionMarketplaceAvailabilityContainer">
                <Text
                    fontSize={16}
                    color="#565656"
                    fontWeight={600}
                    marginBottom={20}
                    textAlign="center"
                    label="Días disponibles para promoción:"
                />
                <div className="promotionMarketplaceAvailabilityDays">
                    {days.map((item, key) => (
                        <button
                            key={key}
                            onClick={() => switchDay(item)}
                            className="promotionMarketplaceAvailabilityBtn"
                            style={{
                                color: validateExistDay(item)
                                    ? 'rgba(38, 153, 214, 1)'
                                    : '#000',
                            }}
                        >
                            <Text
                                label={item}
                                fontSize={12}
                                fontWeight={
                                    validateExistDay(item) ? 'bold' : '400'
                                }
                            />
                        </button>
                    ))}
                </div>
            </div>
        )
    }

    const handleChangeStartTime = (value: string) => {
        handlerChangeData('startTime', value)
        setStartTime(value)
    }

    const handleChangeEndTime = (value: string) => {
        handlerChangeData('endTime', value)
        setEndTime(value)
    }

    const schedule = () => {
        return (
            <>
                <div className="promotionScheduleContainer">
                    <Text
                        fontSize={16}
                        color="#565656"
                        fontWeight={600}
                        marginBottom={20}
                        textAlign="center"
                        label="Horario disponible:"
                    />
                    <div className="promotionScheduleItems">
                        <div className="promotionScheduleItem">
                            <Text
                                fontSize={16}
                                color="#565656"
                                fontWeight={700}
                                label="Desde: "
                            />
                            {inputTime({
                                value: startTime,
                                onChange: handleChangeStartTime,
                                input: {
                                    min: 0,
                                    maxLength: 5,
                                    type: 'text',
                                },
                            })}
                        </div>
                        <div className="promotionScheduleItem">
                            <Text
                                fontSize={16}
                                color="#565656"
                                fontWeight={700}
                                label="Hasta: "
                            />
                            {inputTime({
                                value: endTime,
                                onChange: handleChangeEndTime,
                                input: {
                                    min: 0,
                                    maxLength: 5,
                                    type: 'text',
                                },
                            })}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const Check = (properties: { text: string }) => {
        return (
            <div className="promotionMarketplaceAvailabilityBtn">
                <SquareCheckBox
                    checkId="check-promotion-create"
                    label={properties.text}
                    onClick={() => {
                        handlerChangeData('check', !check)
                        setCheck(!check)
                    }}
                    checked={check}
                />
            </div>
        )
    }

    const step0 = () => {
        return (
            <button
                onClick={handlerNextStep}
                className="promotionMarketplaceStep1Contianer"
            >
                {header()}
            </button>
        )
    }

    const step1 = () => {
        return (
            <>
                {header()}
                {select({ disabled: false })}
            </>
        )
    }

    const step3 = () => {
        return (
            <>
                {header()}
                {select({ disabled: false })}
                {options()}
            </>
        )
    }

    const handleChangeAmount = (value: string) => {
        if (!isNaN(Number(value.trim())) && Number(value) < 0) {
            return
        }

        handlerChangeData('amount', value)
        setAmount(value)
    }

    const handleChangePercentage = (value: string) => {
        if (
            !isNaN(Number(value.trim())) &&
            (Number(value) > 100 || Number(value) < 0)
        ) {
            return
        }

        handlerChangeData('percentage', value)
        setPercentage(value)
    }

    const handleChangeStock = (value: string) => {
        handlerChangeData('stock', value)
        setStock(value)
    }

    const FilterProduct = (properties: {
        selected: IProductSelected | undefined
        onChange: (item: IProductSelected) => void
    }) => {
        const loadOptions = (
            inputValue: string,
            callback: (data: { value: string; label: string }[]) => void
        ) => {
            if (inputValue)
                getFilterProducts(inputValue)
                    .then((success) => {
                        console.log(success.data)
                        callback(
                            success.data.map(
                                (item: {
                                    id: string
                                    sku: string
                                    productStocks: { stock: number }[]
                                    productName: string
                                }) => ({
                                    value: {
                                        sku: String(item.sku),
                                        maximunStock:
                                            item.productStocks[0].stock || 0,
                                    },
                                    label: `(${
                                        item.productStocks[0].stock || 0
                                    }) ${item.productName}`,
                                })
                            )
                        )
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            else callback([])
        }

        return (
            <div className="promotionProductInput">
                <Text
                    fontSize={16}
                    color="#565656"
                    fontWeight={600}
                    marginBottom={20}
                    textAlign="center"
                    label="Selecciona un producto del listado"
                />
                <SelectFilterAsync
                    selected={properties.selected}
                    loadOptions={loadOptions}
                    placeholder="Escriba el nombre de un producto "
                    onChange={(value) => {
                        properties.onChange(value)
                    }}
                />
            </div>
        )
    }

    const options = () => {
        switch (optionSelected) {
            case SectionsEnum.percentage:
                return (
                    <div className="promotionMarketplaceOptionsContainer">
                        {input({
                            value: percentage,
                            onChange: handleChangePercentage,
                            label: 'Porcentaje de descuento (%)',
                            placeholder: '10%',
                            input: {
                                min: 0,
                                max: 100,
                                type: 'number',
                            },
                        })}
                        {input({
                            value: amount,
                            onChange: handleChangeAmount,
                            label: 'Monto mínimo de comprar para efectuar descuento',
                            placeholder: '$10.000',
                            input: {
                                min: 0,
                                type: 'number',
                            },
                        })}
                        <AvailabilityDays />
                        {schedule()}
                        <Check text="No aplican horarios para esta promoción" />
                    </div>
                )
            case SectionsEnum.deliveryFree:
                return (
                    <div className="promotionMarketplaceOptionsContainer">
                        {input({
                            value: amount,
                            onChange: handleChangeAmount,
                            label: 'Monto mínimo de comprar para efectuar descuento',
                            placeholder: '$10.000',
                            input: {
                                min: 0,
                                type: 'number',
                            },
                        })}
                        <AvailabilityDays />
                        {schedule()}
                        <Check text="No aplican horarios para esta promoción" />
                    </div>
                )
            case SectionsEnum.specificProduct:
                return (
                    <div className="promotionMarketplaceOptionsContainer">
                        {input({
                            value: percentage,
                            onChange: handleChangePercentage,
                            label: 'Porcentaje de descuento (%)',
                            placeholder: '10%',
                            input: {
                                min: 0,
                                max: 100,
                                type: 'number',
                            },
                        })}
                        <FilterProduct
                            selected={product}
                            onChange={(value) => {
                                console.log(value)
                                setProduct(value)
                                handlerChangeData('product', value)
                            }}
                        />
                        <div style={{ height: 20 }} />
                        {input({
                            value: stock,
                            onChange: handleChangeStock,
                            label: 'Cantidad de stock',
                            placeholder: '0',
                            input: {
                                min: 0,
                                max: product?.value.maximunStock || 100000,
                                type: 'number',
                            },
                        })}
                        <AvailabilityDays />
                        {schedule()}
                        <Check text="No aplican horarios para esta promoción" />
                    </div>
                )
            default:
                return null
        }
    }

    const manager = () => {
        switch (steps) {
            case 0:
                return step0()
            case 1:
                return step1()
            case 2:
                return step3()
            default:
                return step0()
        }
    }

    return <div className="promotionMarketplaceContainer">{manager()}</div>
}
